import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { store, persistor } from './store'
import BrandingProvider from './theme/brandingContext'
import ThemeProvider from './theme/ThemeProvider'
import App from './App.jsx'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrandingProvider>
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </BrandingProvider>
      </PersistGate>
    </Provider>
  </StrictMode>,
)
